import { useState, useRef, useMemo, useEffect } from "react";
import { noOptionList } from "src/components/collections/helpers";
import { shouldShowSearchField } from "@hyro-components/fields/utils";

const ADD_NEW = "add_new";

export const useSingleSelect = ({ options, field, noOptionsMessage, onFocus, onPopperClose, onAddNewCollection, onChange, open, value, loading }) => {
  const [menuOpen, setMenuOpen] = useState(open);
  const [searchText, setSearchText] = useState("");
  const inputRef = useRef(null);

  const optionsExist = options.length > 0;
  const valueExistsInOptions = options.some(option => option.key === value);
  const showPlaceholder = !valueExistsInOptions && !loading;
  const showSearch = shouldShowSearchField(options);

  const filteredOptions = useMemo(() => {
    const optionsFiltered = options.filter(option =>
      option.display_key.toLowerCase().includes(searchText.toLowerCase())
    );

    if (!optionsExist) return noOptionList(field?.spec?.display_key, noOptionsMessage);

    return optionsFiltered.length === 0
      ? noOptionList(field?.spec?.display_key, noOptionsMessage)
      : optionsFiltered;
  }, [options, searchText, field?.spec?.display_key, optionsExist, noOptionsMessage]);

  useEffect(() => {
    if (menuOpen) {
      onFocus?.(inputRef.current.node);
    } else {
      onPopperClose?.();
    }
  }, [menuOpen, onFocus, onPopperClose]);

  const handleOpen = () => {
    requestAnimationFrame(() => setMenuOpen(true));
  };

  const handleChange = ({ target }) => {
    if (target.value === ADD_NEW) {
      onAddNewCollection();
    } else {
      onChange?.(target.value);
    }
  };

  return {
    menuOpen,
    setMenuOpen,
    searchText,
    inputRef,
    filteredOptions,
    optionsExist,
    showSearch,
    showPlaceholder,
    handleOpen,
    handleChange,
    setSearchText,
    ADD_NEW
  };
};
